/* eslint-disable react/jsx-no-target-blank */
import React from "react"
import { useTranslation, Trans } from 'react-i18next'
import Disclaimer from "../common/Disclaimer"
import { CSSTransition } from 'react-transition-group'
import "../../css/SplashView.css"
import "../../css/Buttons.css"
import "../../css/Transitions.css"
import Config from "../../library/Config"
import SplashForm from "./SplashForm"
import Participant from "../../library/Participant"

interface SplashViewProps {
  config: Config
  currentParticipant: Participant
  handleEnter: (participant: Participant) => void
}

function SplashView({ config, currentParticipant, handleEnter }: SplashViewProps) {
  const { t } = useTranslation()

  let theme = config.theme
  return (
    <section className="splashContainer">
      <CSSTransition in appear timeout={1000} classNames="slideDown" >
        <>
          <header id="headingGroup">
            <div>
              <h1 style={theme.textStyle}>{theme.heading}</h1>
              <h2 style={theme.textStyle}>{theme.subheading}</h2>
            </div>
          </header>

          <SplashForm
            theme={config.theme}
            currentParticipant={currentParticipant}
            buttonTitle={config.buttons.splashJoin ? config.buttons.splashJoin.title : t("splash.letsGo")}
            emailOn={config.dataCapture.emailOn}
            firstNameOn={config.dataCapture.firstNameOn}
            lastNameOn={config.dataCapture.lastNameOn}
            phoneNumberOn={config.dataCapture.phoneNumberOn}
            handleSuccess={(participant) => handleEnter(participant)}
          />

          <Disclaimer theme={theme} />

          {!config.hideAttribution &&
            <div id="poweredBy">
              <a href={theme.poweredBy.url} target="_blank" style={theme.textStyle}>
                <Trans i18nKey="splash.poweredBy" values={{ company: theme.poweredBy.entity }}>
                  Powered by <span className="entity">Simple Booth</span>
                </Trans>
              </a>
            </div>
          }
        </>
      </CSSTransition>
    </section>
  )
}

export default SplashView
